import { use$ } from '@legendapp/state/react';
import { cashoutAnimationState$ } from '../state';
import { CashoutAnimationRenderer } from './CashoutAnimationRenderer';

export const CashoutAnimation = () => {
    const animationType = use$(cashoutAnimationState$.animationType);
    const isVisible = animationType !== 'idle';

    return <CashoutAnimationRenderer style={{ visibility: isVisible ? 'visible' : 'hidden' }} />;
};
